import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import React, { FC, ReactElement } from 'react';
import { Error } from '../../../components/Error';
import { NoResults } from '../../../components/no-results';
import { QueryLoading } from '../../../components/query-loading';
import { IProductAvailability } from '../../../graphql/types';

export const GET_PRODUCT_AVAILABILITY_AT_PLANT = gql`
  query GetProductAvailabilityAtPlant(
    $productId: String!
    $shipToId: String!
    $plantId: String!
  ) {
    productAvailabilityAtPlant(
      productId: $productId
      shipToId: $shipToId
      plantId: $plantId
    ) {
      product {
        id
        description
        salesOrg
        unitOfMeasure
        group
      }
      plant {
        id
        description
      }
      transactions {
        lineIndex
        date
        mrpElement
        elementData
        customerID
        customerName
        requiredQuantity
        calculatedQuantity
      }
      alternativePlants
      extendedPlants
    }
  }
`;

interface IGetProductAvailabilityAtPlantQueryProps {
  productId: string;
  shipToId: string;
  plantId: string;
  render: (productAvailabilityAtPlant: IProductAvailability) => ReactElement;
}

const GetProductAvailabilityAtPlantQuery: FC<IGetProductAvailabilityAtPlantQueryProps> = ({
  productId,
  shipToId,
  plantId,
  render,
}) => {
  const { data, loading, error } = useQuery(GET_PRODUCT_AVAILABILITY_AT_PLANT, {
    variables: {
      productId,
      shipToId,
      plantId,
    },
  });

  if (loading) {
    return <QueryLoading />;
  } else if (error) {
    if (error.message.includes('Material')) {
      return (
        <Error
          heading={error.message.replace('GraphQL error:', '')}
          text={'Please go back to the previous page'}
        />
      );
    }
    if (error.message.includes('Plant')) {
      return (
        <Error
          heading={'Error'}
          text={error.message.replace('GraphQL error:', '')}
        />
      );
    }
    return <Error />;
  } else if (!data || !data.productAvailabilityAtPlant) {
    return <NoResults />;
  }
  return render(data.productAvailabilityAtPlant);
};

export { GetProductAvailabilityAtPlantQuery };
